<template>
  <div class="property-insurance-section">
    <dynamic-calculator :data="data" />
  </div>
</template>

<script>
import DynamicCalculator from "./DynamicCalculator.vue";
export default {
  components: { DynamicCalculator },
  props: ["contentData"],
  data() {
    return {
      data: {
        axiosLink: "getCalcProperty",
        formType: "property",
        header: _.get(this.contentData, "conf.header")
      }
    };
  }
};
</script>

<style lang="scss">
.property-insurance-section {
  .dynamic-content {
    .dynamic-calculator {
      &__form {
        @media (max-width: 1023px) {
          flex-direction: column;
        }
      }
    }
    .row {
      width: 75%;
      @media (max-width: 1023px) {
        width: 100%;
      }
    }
    .radio,
    .checkbox {
      display: flex;
      flex-direction: column;
    }
    .input-grid {
      display: grid;
      grid-template-columns: [col1-start] 0.5fr [col2-start] 0.5fr [col3-start];
      grid-template-rows: [row1-start] auto [row2-start];
      @media (max-width: 1023px) {
        display: flex;

        flex-direction: column;
      }

      .el-form-item {
        &:first-child {
          grid-column: col1-start / col3-start;
          grid-row: row1-start;
        }
        &:nth-child(2) {
          grid-column: col1-start;
          grid-row: row2-start;
        }
        &:nth-child(3) {
          grid-column: col2-start;
          grid-row: row2-start;
        }
      }
    }
  }
}
</style>
